// checkout/utils/handleOrderSummary.ts

/**
 * Toggles the visibility of the order summary element based on the current window width.
 * @returns {void}
 */
export function toggleOrderSummary(): void {
	const currentWindowWidth = window.innerWidth;
	const orderSummary = document.getElementById('order-summary') as HTMLElement;
	if (!orderSummary) return;

	if (currentWindowWidth > 839) {
		orderSummary.setAttribute('open', '');
	} else {
		if (orderSummary.hasAttribute('open') && currentWindowWidth !== window.windowWidth) {
			orderSummary.removeAttribute('open');
		}
	}
}

/**
 * Detects vertical scrolling on the order summary list and toggles
 * a `scrolling` CSS class on its wrapper when the list is scrolled.
 * Only applies when the wrapper has the `list--large` class and the window width is greater than 839.
 * @returns {void}
 */
export function detectOrderSummaryScroll(): void {
	const currentWindowWidth = window.innerWidth;
	const orderSummaryList = document.querySelector('.order-summary__list') as HTMLElement;
	const orderSummaryListWrapper = document.querySelector(
		'.order-summary__list-wrapper',
	) as HTMLElement;

	if (!orderSummaryList && !orderSummaryListWrapper) return;

	if (currentWindowWidth > 839 && orderSummaryListWrapper.classList.contains('list--large')) {
		orderSummaryList.addEventListener('scroll', () => {
			if (orderSummaryList.scrollTop > 0) {
				requestAnimationFrame(() => {
					orderSummaryListWrapper.classList.add('scrolling');
				});
			} else {
				orderSummaryListWrapper.classList.remove('scrolling');
			}
		});
	}
}

/**
 * Re-initialises order summary behaviour.
 * Call this on initial page load and after the order summary HTML is replaced.
 * @returns {void}
 */
export function initOrderSummary(): void {
	toggleOrderSummary();
	detectOrderSummaryScroll();
}
